import { useReadQuery } from '@apollo/client';
import { Button, ButtonProps } from '@synoptic/ui-kit/button/button.js';
import {
  TournamentFieldsFragmentFragment,
  TournamentState,
} from '@/__generated__/graphql.ts';
import { Tournament } from '@/__generated__/schema-types.ts';
import {
  TournamentType,
  determinateTournamentType,
} from '@/components/tournaments/determinate-tournament-type.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { useTournamentLoaderData } from './loader.ts';
import { NewTournamentPostModal } from './new-tournament-post-modal.tsx';

export const TournamentCta = ({
  size = 'medium',
}: {
  size?: ButtonProps['size'];
}) => {
  const { queryRef } = useTournamentLoaderData();
  const {
    data: { tournament },
  } = useReadQuery(queryRef);
  const tournamentType = determinateTournamentType(
    (tournament as Tournament)?.fields as TournamentFieldsFragmentFragment[],
  );

  const id = tournament?.id;
  const state = tournament?.state;

  if (!id || !state) return null;

  switch (state) {
    case TournamentState.Active:
      return tournamentType === TournamentType.Prediction ? (
        <Button size={size} asChild>
          <Link to={paths.makeQuestionnaire(id)}>Submit Post</Link>
        </Button>
      ) : (
        <NewTournamentPostModal
          trigger={<Button size={size}>Submit Post</Button>}
          tournamentId={id}
        />
      );
    case TournamentState.Processing:
      return (
        <Button size={size} asChild>
          <Link to={paths.makeDiscussions(id)}>Check discussions</Link>
        </Button>
      );
    case TournamentState.Preliminary:
      return (
        <Button size={size} asChild>
          <Link to={paths.makeParticipants(id)}>Check Preliminary Results</Link>
        </Button>
      );
    case TournamentState.Final:
      return (
        <Button size={size} asChild>
          <Link to={paths.makeParticipants(id)}>Check Final Results</Link>
        </Button>
      );
    default:
      return (
        <Button size={size} disabled>
          Submit Post
        </Button>
      );
  }
};
